import { render, staticRenderFns } from "./AddPurchasedPartComponent.vue?vue&type=template&id=ffe490ec&scoped=true&"
import script from "./AddPurchasedPartComponent.vue?vue&type=script&lang=ts&"
export * from "./AddPurchasedPartComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AddPurchasedPartComponent.vue?vue&type=style&index=0&id=ffe490ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe490ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
